<template>
  <div v-if="!isLoading && survey != null">
    <h2>サーベイ目標管理</h2>
    <v-tabs v-model="active" color="cyan" dark slider-color="yellow">
      <v-tab>概要</v-tab>
      <v-tab>担当者</v-tab>
      <v-tab>対象者・協力者</v-tab>
      <v-tab>スケジュール</v-tab>
      <v-tab v-if="auths.includes('ReadAutoMail')">自動メール</v-tab>
      <v-tab v-if="auths.includes('ReadSendMail')">送信済メール</v-tab>
      <v-tab v-if="auths.includes('ReadSelectQuestions')">選択質問</v-tab>
      <v-tab v-if="auths.includes('ReadCommentQuestions')">コメント質問</v-tab>
      <v-tab v-if="auths.includes('ReadStartEndPage')">開始・終了ページ</v-tab>
      <v-tab v-if="auths.includes('ReadAndEditSurveyResults')">結果確認</v-tab>
      <v-tab v-if="has_target">目標設定</v-tab>
      <v-tab-item>
        <info-table :infoItems="infoItems" @updateItem="updateInfo" />
      </v-tab-item>
      <v-tab-item>
        <contact-table
          :contacts="survey.contacts"
          @updateItem="updateContacts"
        />
      </v-tab-item>

      <v-tab-item>
        <users-table :answerItems="answers" />
      </v-tab-item>
      <v-tab-item>
        <schedules-table :survey="survey" :schedules="schedules" />
      </v-tab-item>
      <v-tab-item v-if="auths.includes('ReadAutoMail')">
        <auto-mail :survey="survey" :schedule-dictionary="scheduleDictionary" />
      </v-tab-item>
      <v-tab-item v-if="auths.includes('ReadSendMail')">
        <send-mail :survey="survey" />
      </v-tab-item>
      <v-tab-item v-if="auths.includes('ReadSelectQuestions')">
        <select-questions-table
          :items="survey.question_sheet.sections[selectSections[0]]"
          @updateQuestions="updateQuestions"
          @hello="hello"
        />
      </v-tab-item>
      <v-tab-item>
        <comment-questions-table
          :items="commentSections"
          @updateCommentQuestion="updateCommentQuestion"
          v-if="auths.includes('ReadCommentQuestions')"
        />
      </v-tab-item>
      <v-tab-item>
        <start-end-page
          :startPage="survey.question_sheet.sections[0]"
          :endPage="
            survey.question_sheet.sections[
              survey.question_sheet.sections.length - 1
            ]
          "
          :insertFileds="insertFileds"
          @updateQuestions="updateQuestions"
          v-if="auths.includes('ReadStartEndPage')"
        />
      </v-tab-item>
      <v-tab-item v-if="auths.includes('ReadAndEditSurveyResults')">
        <results-table :answerItems="answers" />
      </v-tab-item>
      <v-tab-item>
        <targets-table
          :target_id="target_id"
          :challange-sheets="challengeSheets"
          @updateItems="getChallengeSheets"
        />
      </v-tab-item>
    </v-tabs>
    <v-btn color="green" class="white--text" @click="downloadFile">
      <v-icon color="white">cloud_download</v-icon>ダウンロード
    </v-btn>
  </div>
</template>


<script>
import db from "@/components/firebaseInit";
import InfoTable from "@/components/manage_survey/info_table";
import ContactTable from "@/components/manage_survey/contact_table";
import UsersTable from "@/components/manage_survey/users_table";
import SelectQuestionsTable from "@/components/manage_survey/select_questions_table";
import CommentQuestionsTable from "@/components/manage_survey/comment_questions_table";
import SchedulesTable from "@/components/manage_survey/schedules_table";
import AutoMail from "@/components/manage_survey/auto_mail";
import SendMail from "@/components/manage_survey/send_mail";
import StartEndPage from "@/components/manage_survey/start_end_page";
import TargetsTable from "@/components/manage_survey/targets_table";
import ResultsTable from "@/components/manage_survey/results_table";

import { mapGetters, mapMutations, mapActions } from "vuex";
import { scheduleDictionary } from "@/utils/schedules.js";
import {
  unixtimeToShortJapaneseFormattedDatetime,
  unixtimeToShortJapaneseFormattedDate,
} from "@/utils/datetime.js";

export default {
  components: {
    InfoTable,
    ContactTable,
    UsersTable,
    SelectQuestionsTable,
    CommentQuestionsTable,
    SchedulesTable,
    AutoMail,
    SendMail,
    StartEndPage,
    TargetsTable,
    ResultsTable,
  },
  data() {
    return {
      items: [],
      active: null,
      categorys: [],
      selectOptions: [],
      summary: { avgSelf: null, avgScore: null, sdScore: null },
      summaryItems: {},
      answers: [],
      challengeSheets: [],
      survey: null,
      questions: [],
      selectSections: [],
      commentSections: [],
      infoItems: {
        subjectName: "",
        startDate: "",
        endDate: "",
        numOfCoWorker: 0,
      },
      surveyDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      subjects: {},
      users: {},
      schedules: [],
      has_target: false,
      target_id: "",
      insertFileds: [],
      scheduleDictionary: scheduleDictionary,
    };
  },
  created() {},
  mounted() {
    this.getAnswers();
  },
  updated() {},
  methods: {
    hello() {
      console.log("hello");
    },
    async getChallengeSheets() {
      this.challengeSheets = [];
      if (this.has_target) {
        try {
          this.changeLoadingState(true);
          const items = await db
            .collection("companies")
            .doc(this.$route.params.company_id)
            .collection("challenge_sheets")
            .where("survey_id", "==", this.$route.params.survey_id)
            .get();
          items.forEach((doc) => {
            this.challengeSheets.push({ ...doc.data(), id: doc.id });
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.changeLoadingState(false);
        }
      }
    },
    async getAnswers() {
      this.changeLoadingState(true);

      this.answerDbRef.onSnapshot((querySnapshot) => {
        this.answers = [];
        this.subjects = {};
        this.users = {};
        querySnapshot.forEach((doc) => {
          const ans = doc.data();
          ans.id = doc.id;
          let hasZero = false;
          // debugger
          // Object.keys(ans.result[1]).forEach((k) => {
          //   if (Number(ans.result[1][k]) <= 0) {
          //     hasZero = true;
          //     console.log(k);
          //   }
          // });
          if (hasZero) console.error(ans);
          this.answers.push(ans);
          this.subjects[ans.subject_id] = true;
          this.users[ans.user_id] = true;
        });

        this.getSurvey();
      });
    },
    async getSurvey() {
      const doc = await this.surveyDbRef.get();
      this.survey = doc.data();
      this.has_target = this.survey.has_target;
      this.target_id = this.has_target ? this.survey.target_id : "";

      this.commentSections = { index: [] };
      this.survey.question_sheet.sections
        .filter((s, i) => {
          if (s.type == "SelectQuestions") {
            this.selectSections.push(i);
            return true;
          } else if (s.type == "CommentQuestions") {
            this.commentSections.index.push(i);
            this.commentSections[i] = {
              ...s,
              comments: { subject: [], coWorker: [] },
            };
          }
        })
        .forEach((s) => {
          s.questions.forEach((q) => this.questions.push(q));
        });
      this.categorys = this.selectSections[0]
        ? this.survey.question_sheet.sections[this.selectSections[0]]
            .categoryList
        : [];

      this.selectOptions = this.selectSections[0]
        ? this.survey.question_sheet.sections[this.selectSections[0]]
            .selectOptions
        : [];
      this.updateInfoItems();
      this.schedules = [];
      scheduleDictionary.forEach((sch) => {
        if (this.survey.has_target || !sch.onlyHasTarget) {
          this.schedules.push({
            name: sch.name,
            key: sch.key,
            datetime: this.survey[sch.key],
          });
          this.insertFileds.push({
            find: sch.name + "日時",
            replace: unixtimeToShortJapaneseFormattedDatetime(
              this.survey[sch.key]
            ),
          });
        }
      });
      this.insertFileds.push({ find: "研修名", replace: this.survey.name });
      this.insertFileds.push({
        find: "研修日",
        replace: unixtimeToShortJapaneseFormattedDate(
          this.survey.training_date
        ),
      });
      this.getChallengeSheets();
      this.changeLoadingState(false);
    },
    updateInfoItems() {
      this.infoItems = Object.assign({}, this.infoItems, {
        name: this.survey.name,
        start_date: this.survey.start_date,
        end_date: this.survey.end_date,
        training_date: this.survey.training_date,
        num_of_subjects: Object.keys(this.subjects).length,
        num_of_users: this.answers.filter((ans) => ans.type == "coWorker")
          .length,
      });
    },
    async updateQuestions() {
      this.changeLoadingState(true);
      await this.surveyDbRef
        .set(
          { question_sheet: { sections: this.survey.question_sheet.sections } },
          { merge: true }
        )
        .catch((e) => {
          console.error("Error writing document: ", e);
        });
      this.getSurvey();
    },
    updateCommentQuestion(question) {
      this.survey.question_sheet.sections[question.section_no] =
        question.question;
      this.updateQuestions();
    },
    async updateInfo(info) {
      this.changeLoadingState(true);
      await this.surveyDbRef.set({ ...info }, { merge: true }).catch((e) => {
        console.error("Error writing document: ", e);
      });
      this.getSurvey();
    },
    async updateContacts() {
      await this.surveyDbRef
        .set({ contacts: this.survey.contacts }, { merge: true })
        .catch((e) => {
          console.error("Error writing document: ", e);
        });
      this.getSurvey();
    },
    downloadFile() {
      var FileSaver = require("file-saver");
      let fileName = "answers-"  + ".json";
      let strJson = JSON.stringify(this.answers, null, 4);
      // console.log(JSON.stringify(this.items));
      // let fileToSave = new Blob([JSON.stringify(this.itmes, null, 4)], {
      //   type: "application/json",
      //   name: fileName,
      // });
      let fileToSave = new Blob([strJson], {
        type: "application/json",
        name: fileName,
      });
      FileSaver.saveAs(fileToSave, fileName);
    },
    ...mapActions("app", ["changeLoadingState"]),
  },

  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "auths"]),
    ...mapGetters("app", ["isLoading"]),
  },
};
</script>

<style lang="scss" scoped>
.result-row {
  margin: 10px 0;
}
</style>
